import React, { useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { updateProfile } from '../../actions/accountActions'
import { updatePasswordFormValid } from '../../validation'
import {
    convertErrorYup,
    errorHandle,
    ensureArray,
    showMessageSuccess,
} from '../../utils/helper'
import UpdatePasswordModal from '../../components/auth/UpdatePasswordModal'
import useDidMountEffect from '../../hooks/useDidMountEffect'
import { useTranslation } from 'react-i18next'

const defaultForm = {}

const UpdatePasswordModalContainer = ({ isOpen, setIsOpen }) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const user = useSelector(state => state.AccountReducer.user)

    const [form, setForm] = useState({ ...defaultForm })
    const [errors, setErrors] = useState({})

    const handleInputChange = e => {
        const { name, value } = e.target
        setForm(prev => ({ ...prev, [name]: value }))
    }

    const clearErrorField = field =>
        setErrors(prev => ({ ...prev, [field]: '' }))

    const handleSubmit = async e => {
        e && e.preventDefault()

        try {
            await updatePasswordFormValid.validate(form, { abortEarly: false })
            const { userPassword, userNewPassword } = form
            dispatch(
                updateProfile({
                    params: {
                        ...user,
                        userPassword,
                        userNewPassword,
                        fromShopId: 27,
                    },
                    onDone: ({ responseData, success }) => {
                        if (success) {
                            setForm({ ...defaultForm })
                            // show message success
                            setIsOpen(false)
                            showMessageSuccess(
                                t('apiMessage.changePasswordSuccess')
                            )
                        } else {
                            if (responseData?.data) {
                                setErrors(
                                    ensureArray(responseData?.data).reduce(
                                        (rs, current) => ({
                                            ...rs,
                                            [current.field]: current.message,
                                        }),
                                        {}
                                    )
                                )
                            } else {
                                errorHandle({
                                    message: 'apiMessage.changePasswordFailed',
                                })
                            }
                        }
                    },
                })
            )
        } catch (error) {
            if (error?.name === 'ValidationError') {
                setErrors(convertErrorYup(error))
            }
        }
    }

    useDidMountEffect(() => {
        if (!isOpen) {
            setForm({ ...defaultForm })
            setErrors({})
        }
    }, [isOpen])

    return (
        <UpdatePasswordModal
            handleSubmit={handleSubmit}
            form={form}
            handleInputChange={handleInputChange}
            clearErrorField={clearErrorField}
            errors={errors}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
        />
    )
}

export default UpdatePasswordModalContainer
